<template>
	<div>
		<!-- 面包屑导航 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>发展对象权限</el-breadcrumb-item>
			<el-breadcrumb-item>微心愿</el-breadcrumb-item>
		</el-breadcrumb>

		<div class="tabname">
			<el-tabs v-model="activeName2">
				<!-- 党员联系老师名单管理-->
				<el-tab-pane name="dyjslist">
					<span slot="label"><i class="el-icon-date"></i> 入党申请书</span>
					<!-- 第一行搜索框和新增按钮 -->
					<el-row type="flex" align="middle" class="myRow">
						<el-col :offset="1">
							<el-button type="primary" @click="addDialogVisible = true">新增申请书</el-button>
						</el-col>
					</el-row>
					<!--上传申请书按钮对话框-->
					<el-dialog title="上传材料" :visible.sync="addDialogVisible" width="30%">
						<el-form :model="addForm"  ref="addFormRef" label-width="100px">

							<el-form-item label="申请时间" prop="time">
								<el-date-picker type="date" placeholder="选择日期" v-model="addForm.date2" style="width: 100%;">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="" prop="name">
								<el-upload class="upload-demo" accept=".pdf" drag
									action="http://36.134.183.225:9898/shenqingshu/upload" multiple :headers="this.token"
									:before-upload="handleBeforeUpload">
									<i class="el-icon-upload"></i>
									<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
									<div class="el-upload__tip" slot="tip">只能上传PDF文件，且不超过2M</div>
								</el-upload>
							</el-form-item>
						</el-form>
						<span slot="footer" class="dialog-footer">
							<el-button @click="addDialogVisible = false">取 消</el-button>
							<el-button type="primary" @click="myUpload()">确 定</el-button>
						</span>
					</el-dialog>
					<!-- 得分列表-->
					<el-table border stripe height="620px" :data="fileList" :header-cell-style="{
						background: '#fff1f0', height: '60px', color: '#000000'
					}">
						<el-table-column type="index" label="序号" width="50px"> </el-table-column>

						<el-table-column prop="fileName" label="文件名称" width="250px">
						</el-table-column>
						<el-table-column prop="createTime" label="创建时间" width="220px">
						</el-table-column>
						<el-table-column prop="fullName" label="姓名" width="120px">
						</el-table-column>
						<el-table-column prop="banji" label="班级" width="150x">
						</el-table-column>
						<el-table-column label="操作" width="300px">
							<template slot-scope="scope">
								<el-button @click="downloadCertin(scope.row.fileName)" size="small"
									icon="el-icon-download">下载文件</el-button>
								<el-popconfirm @confirm="myDelete(scope.row.fileName)" title="确定要删除该文件吗？">
									<el-button type="danger" slot="reference" size="small" title="删除文件"
										icon="el-icon-delete">删除文件</el-button>
								</el-popconfirm>

							</template>
						</el-table-column>
					</el-table>
				</el-tab-pane>
				<el-tab-pane>
					<span slot="label"><i class="el-icon-date"></i> 思想汇报、帮扶计划</span>
					<!-- 第一行搜索框和新增按钮 -->
					<el-row type="flex" align="middle" class="myRow">
						<el-col :span="5">活动类型</el-col>
						<el-col :span="10">
							<el-select v-model="queryInfo.type" placeholder="请选择" filterable @change="mygetActivityList()">
								<el-option v-for="item in wxytype" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-col>
						<el-col :span="5" :offset="1">活动搜索</el-col>
						<el-col :span="15">
							<el-input placeholder="请输入活动名称" v-model="queryInfo.name" clearable>
								<el-button slot="append" icon="el-icon-search" @click="mygetActivityList()"></el-button>
							</el-input>
						</el-col>
						<el-col :offset="1">
							<el-button type="primary"
								@click="addActiStep1Visible = true; addActiStep2Visible = true">新增活动</el-button>
						</el-col>
					</el-row>
                    <!-- 新增活动对话框-->
		<el-dialog title="新增活动" :visible.sync="addActiStep1Visible" width="30%" >
			<el-form :model="addActiForm" :rules="addActiFormRules" ref="addActiFormRef" label-width="100px"
				v-if="addActiStep2Visible">
				<div style="margin-bottom: 30px;font-size: 18px;font-weight: 600;">Step1:填写活动基本信息</div>
				<el-form-item label="活动类型" prop="type">
					<el-select v-model="addActiForm.type" placeholder="请选择" filterable>
						<el-option v-for="item in wxytype" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="活动名称" prop="name">
					<el-input v-model="addActiForm.name" placeholder="例如：2023年第一季度思想汇报"></el-input>
				</el-form-item>
				<el-form-item label="活动时间" prop="date">
					<el-date-picker type="date" placeholder="选择日期" v-model="addActiForm.date" style="width: 100%;"
						value-format="yyyy-MM-dd">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="活动分值" prop="score">
					<el-input v-model="addActiForm.score"></el-input>
				</el-form-item>

			</el-form>

			<div label-width="100px" v-else>
				<div style="margin-bottom: 30px;font-size: 15px;font-weight: 700;">Step2:上传活动证明</div>
				<div>
					<el-upload class="upload-demo" accept=".jpg,.png,.jpeg" drag   :action="this.action" multiple :headers="this.token" :on-change="loadJsonFromFile">
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
						<div class="el-upload__tip" slot="tip">只能上传JPG,JPEG,PNG等格式的图片，且不超过2M</div>
					</el-upload>
				</div>
			</div>
			<span slot="footer" class="dialog-footer" v-if="addActiStep2Visible">
				<el-button @click="addActiStep1Visible = false">取 消</el-button>
				<el-button type="primary" @click="myaddActivityStep1()">确 定</el-button>
			</span>
			<span slot="footer" class="dialog-footer" v-else>
				<el-button @click="addActiStep1Visible = false">取 消</el-button>
				<el-button type="primary" @click="myaddActivityStep2()">完 成</el-button>
			</span>
		</el-dialog>
			<!-- 得分列表-->
			<el-table border :show-summary="true" :header-row-style="{ height: '60px' }" :row-style="{ height: '30px' }"
			:data="wxyList" :highlight-current-row='true' :header-cell-style="{
				background: '#fff1f0', height: '60px', color: '#000000'
			}">
			<el-table-column type="index" label="序号" width="50px"> </el-table-column>
			<el-table-column prop="type" label="活动类型" width="250px">
			</el-table-column>
			<el-table-column prop="name" label="活动名称" width="300px">
			</el-table-column>

			<el-table-column prop="date" label="活动日期" width="200px">
			</el-table-column>
			<el-table-column prop="score" label="活动分值" width="100x">
			</el-table-column>
			<el-table-column prop="approve" label="活动状态" width="100x">
			</el-table-column>
			<el-table-column label="操作" width="450px">
				<template slot-scope="scope">
					<el-button  @click="handleApprove(scope.row)" size="small" icon="el-icon-search">
						查看活动</el-button>
					<el-button type="danger" @click="mydeleteActivity(scope.row.id)" size="small" icon="el-icon-delete">
						删除活动</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!--分页区域-->
		<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
			:current-page="queryInfo.pageNo" :page-sizes="[1, 5, 30, 50]" :page-size="queryInfo.pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total=count>
		</el-pagination>
		<!-- 查看活动对话框-->
		<el-dialog title="查看活动" :visible.sync="showDialogVisible" width="35%">
            <el-form :model="approveForm">
                <el-form-item label="活动类型：" prop="type">
                    <span style="margin-left: 5px" >{{ approveForm.type }}</span>
                </el-form-item>
                <el-form-item label="活动名称:" prop="name">
                    <span style="margin-left: 5px" >{{ approveForm.name }}</span>
                </el-form-item>
                <el-form-item label="活动时间:" prop="date">
                    <span style="margin-left: 5px" >{{ approveForm.date }}</span>
                </el-form-item>
                <el-form-item label="活动分值:" prop="score">
                    <span style="margin-left: 5px" >{{ approveForm.score }}</span>
                </el-form-item>
                <el-form-item label="活动附件:">
                    <div v-for="item in approveForm.currentFiles"  :key="item.value" class="img_container">
                        <viewer>
                        <img :src=getFileUrl(approveForm,item.fileName)>
                        </viewer>
                    </div>
                </el-form-item>
              
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showDialogVisible = false">关闭</el-button>
             
            </span>
        </el-dialog>

				</el-tab-pane>
				<el-tab-pane>
					<span slot="label"><i class="el-icon-date"></i> 青年大学习</span>
		<!-- 第一行搜索框和新增按钮 -->
		<el-row type="flex" align="middle" class="myRow">
			<el-col :span="5">活动类型</el-col>
			<el-col :span="10">
				<el-select v-model="queryInfo.type" placeholder="请选择" filterable @change="mygetActivityList()">
					<el-option v-for="item in qnxx" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</el-col>
			<el-col :span="5" :offset="1">活动搜索</el-col>
			<el-col :span="15">
				<el-input placeholder="请输入活动名称" v-model="queryInfo.name" clearable>
					<el-button slot="append" icon="el-icon-search" @click="mygetActivityList()"></el-button>
				</el-input>
			</el-col>
			<el-col :offset="1">
				<el-button type="primary"
					@click="addActiStep1Visible = true; addActiStep2Visible = true">新增活动</el-button>
			</el-col>
		</el-row>
		<!-- 新增活动对话框-->
		<el-dialog title="新增活动" :visible.sync="addActiStep1Visible" width="30%" >
			<el-form :model="addActiForm" :rules="addActiFormRules" ref="addActiFormRef" label-width="100px"
				v-if="addActiStep2Visible">
				<div style="margin-bottom: 30px;font-size: 18px;font-weight: 600;">Step1:填写活动基本信息</div>
				<el-form-item label="活动类型" prop="type">
					<el-select v-model="addActiForm.type" placeholder="请选择" filterable>
						<el-option v-for="item in qnxx" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="活动名称" prop="name">
					<el-input v-model="addActiForm.name"></el-input>
				</el-form-item>
				<el-form-item label="活动时间" prop="date">
					<el-date-picker type="date" placeholder="选择日期" v-model="addActiForm.date" style="width: 100%;"
						value-format="yyyy-MM-dd">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="活动分值" prop="score">
					<el-input v-model="addActiForm.score"></el-input>
				</el-form-item>
			</el-form>

			<div label-width="100px" v-else>
				<div style="margin-bottom: 30px;font-size: 15px;font-weight: 700;">Step2:上传活动证明</div>
				<div>
					<el-upload class="upload-demo" accept=".jpg,.png,.jpeg" drag :action="this.action"  :file-list="uploadList" multiple :headers="this.token" :on-change="loadJsonFromFile">
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
						<div class="el-upload__tip" slot="tip">只能上传JPG,PNG,IPEG等文件，且不超过2M</div>
					</el-upload>
				</div>
			</div>
			<span slot="footer" class="dialog-footer" v-if="addActiStep2Visible">
				<el-button @click="addActiStep1Visible = false">取 消</el-button>
				<el-button type="primary" @click="myaddActivityStep1()">确 定</el-button>
			</span>
			<span slot="footer" class="dialog-footer" v-else>
				<el-button @click="addActiStep1Visible = false">取 消</el-button>
				<el-button type="primary" @click="myaddActivityStep2()">完 成</el-button>
			</span>
		</el-dialog>
		<!-- 得分列表-->
		<el-table border :show-summary="true" :header-row-style="{ height: '60px' }" :row-style="{ height: '30px' }"
			:data="qnxxList" :highlight-current-row='true' :header-cell-style="{
				background: '#fff1f0', height: '60px', color: '#000000'
			}">
			<el-table-column type="index" label="序号" width="50px"> </el-table-column>
			<el-table-column prop="type" label="活动类型" width="250px">
			</el-table-column>
			<el-table-column prop="name" label="活动名称" width="300px">
			</el-table-column>

			<el-table-column prop="date" label="活动日期" width="200px">
			</el-table-column>
			<el-table-column prop="score" label="活动分值" width="100x">
			</el-table-column>
			<el-table-column prop="approve" label="活动状态" width="100x">
			</el-table-column>
			<el-table-column label="操作" width="250px">
				<template slot-scope="scope">
					<el-button  @click="handleApprove(scope.row)" size="small" icon="el-icon-search">
						查看活动</el-button>
					<el-button type="danger" @click="mydeleteActivity(scope.row.id)" size="small" icon="el-icon-delete">
						删除活动</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="approveReason" label="审核（退回）理由" width="150x">
            </el-table-column>
		</el-table>
		<!--分页区域-->
		<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
			:current-page="queryInfo.pageNumber" :page-sizes="[1, 5, 30, 50]" :page-size="queryInfo.pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total=count>
		</el-pagination>
		 <!-- 查看活动对话框-->
		 <el-dialog title="查看活动" :visible.sync="showDialogVisible" width="35%">
            <el-form :model="approveForm">
                <el-form-item label="活动类型：" prop="type">
                    <span style="margin-left: 5px" >{{ approveForm.type }}</span>
                </el-form-item>
                <el-form-item label="活动名称:" prop="name">
                    <span style="margin-left: 5px" >{{ approveForm.name }}</span>
                </el-form-item>
                <el-form-item label="活动时间:" prop="date">
                    <span style="margin-left: 5px" >{{ approveForm.date }}</span>
                </el-form-item>
                <el-form-item label="活动分值:" prop="score">
                    <span style="margin-left: 5px" >{{ approveForm.score }}</span>
                </el-form-item>
                <el-form-item label="活动附件:">
                    <div v-for="item in approveForm.currentFiles"  :key="item.value" class="img_container">
                        <viewer>
                        <img :src=getFileUrl(approveForm,item.fileName)>
                        </viewer>
                    </div>
                </el-form-item>
              
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showDialogVisible = false">关闭</el-button>
             
            </span>
        </el-dialog>

				</el-tab-pane>
			</el-tabs>
		</div>

	</div>
</template>

<script>
import { listFiles,getShenqingshu, deleMyShenqingshu, downloadMyShenqingshu,addActivity, deleteActivity, listCurrentActivity  } from "../../utils/api";
import { getToken } from '../../utils/auth';
import axios from "axios";


export default {
	data() {
		return {
			addForm: {
				date2: '',
				type: '',
			},
			codeNumber:'',
			//查看活动对话框的显示与隐藏
			showDialogVisible: false,
			approveForm: {
                userId:'',
                type: '',
                name: '',
                date: '',
                score: '',
                id: '',
                fullName:'',
                banji:'',
                fullName:'',
                currentFiles: '',
                approve: -1,
                
            },
			activeName2: 'dyjslist',
			wxyList:[],
			qnxxList:[],
			token: {},
			//控制上传申请书对话框的显示与隐藏
			addDialogVisible: false,
			fileList: [],
              //文件上传列表
			  uploadList:[],
			 //控制上传申请书对话框的显示与隐藏
			 addActiStep1Visible: false,
			addActiStep2Visible: false,
			queryInfo: {
				name: '',
				dateStart: '',
				dateEnd: '',
				createTimeStart: '',
				createTimeEnd: '',
				type: '',
				pageSize: 30,
				pageNumber: 1,
				approve: '-1',

			},
			action: 'http://36.134.183.225:9898/activity/uploadFile',
			addActiForm: {
				type: '',
				name: '',
				date: '',
				score: ''
			},
			//微心愿活动类型下拉菜单选项
			wxytype: [
				{
					value: '',
					label: '请选择'
				},
				{
					value: "微心愿_思想汇报",
					label: "微心愿_思想汇报",
				}, {
					value: "微心愿_帮扶计划",
					label: "微心愿_帮扶计划"
				}
			],
			//青年大学习下拉菜单选项
			qnxx: [
				{
					value: '',
					label: '请选择'
				},
				{
					value: "微心愿_青年大学习",
					label: "微心愿_青年大学习",
				}
			],
			addActiFormRules: {
				type: [{
					required: true, message: "请选择活动类型"
				}],
				name: [{
					required: true, message: "请填写活动名称"
				}],
				score: [{
					required: true, message: "请填写活动分数"
				}],
				date: [{
					required: true, message: "请填写活动日期"
				}],
			}
		}
	},
	created() {
		this.myToken();
		this.myUpload();
		this.mygetActivityList();
	},
	methods: {
		loadJsonFromFile(file, fileList) {
      this.uploadList = fileList;
	  console.log(this.uploadList);
    },
		myUpload() {
			//获取到文件列表
			getShenqingshu().then(result => {
				if (result.code === '0000') {
					this.fileList = result.data;
					this.addDialogVisible = false;
				} else {
					console.log(result)
				}
			})
		},
		myDelete(id) {
			const param = { "fileName": id }
			deleMyShenqingshu(param).then(result => {
				if (result.code === '0000') {
					this.$message.success(result.message);
					this.myUpload();
				} else {
					console.log(result)
				}
			})
		},
		downloadCertin(id) {
			const param = { "fileName": id }
			downloadMyShenqingshu(param.fileName).then(result => {
				const link = document.createElement('a');  // 创建元素
				let blob = new Blob([result]);
				link.style.display = 'none';
				link.href = URL.createObjectURL(blob);   // 创建下载的链接
				link.setAttribute('download', id);  // 给下载后的文件命名 fileName文件名  type文件格式
				document.body.appendChild(link);
				link.click();  // 点击下载
				document.body.removeChild(link);  //  下载完成移除元素
				window.URL.revokeObjectURL(link.href);  // 释放掉blob对象
			})

		},

		myToken() {
			const retoken = getToken();
			this.token = { Authorization: retoken };
		},// 文件上传前触发
		handleBeforeUpload(file) {
			// 拿到文件后缀名
			const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
			console.log('文件上传类型', fileType)
			// 当然拉我的需求是只需要图片和pdf，大家有需要可以在此处扩展

			const isPdf = fileType === 'pdf';
			console.log("terrible", isPdf);
			const isLt2M = file.size / 2048 / 1024 < 1;
			// 根据后缀名判断文件类型
			if (!isPdf) {
				console.log("terrible");
				this.$message.error('只能上传PDF文件');
				return false
			}
			// 可以限制图片的大小
			if (!isLt2M) {
				this.$message.error('上传图片大小不能超过 2MB!');
			}
		},
		myaddActivityStep1() {		
				addActivity(this.addActiForm).then(result => {
					
					this.codeNumber=result.data;
					console.log(this.codeNumber);
				if (result.code === '0000') {
					this.$message.success(result.message);
					this.action = 'http://36.134.183.225:9898/activity/uploadFile?id=' + result.data;
					this.addActiStep2Visible = false;
					Object.assign(this.$data.addActiForm, this.$options.data().addActiForm);
				
				} else {
					console.log(result)
				}
			})
		
		},
		myaddActivityStep2() {
			
		if(this.uploadList.length==0){
			this.$message.error('未上传附件，活动创建失败');
			this.mydeleteActivity(this.codeNumber);
			this.addActiStep1Visible = false;
			this.uploadList=[];
		}else{
			this.addActiStep1Visible = false;
			this.mygetActivityList();
			this.uploadList=[];
		}
			
		},
		//监听PageSize的长度
		handleSizeChange(newSize) {
			this.queryInfo.pageSize = newSize;
			this.mygetActivityList();

		},
		//监听页码值改变的事件
		handleCurrentChange(newPage) {
			this.queryInfo.pageNumber = newPage;
			this.mygetActivityList();
	
		},
		async handleApprove(row) {
			console.log('aaaa');
			console.log(row);
            this.approveForm = row;
            this.approveForm.currentFiles = await this.mylistCurrentFiles()
			
            this.showDialogVisible = true;

        },
		
        getFileUrl(approveForm,file){
            return axios.defaults.baseURL+'/activity/downloadFile?userId='+approveForm.userId+'&id='+approveForm.id+'&fileName='+file+'&token='+getToken()
        },
   
        async mylistCurrentFiles() {
            let files = []
			console.log('bbbb');
            await listFiles({ id: this.approveForm.id, userId: this.approveForm.userId }).then(result => {
				console.log('ccccc');
                if (result.code === '0000') {
                    for (let i in result.data) {
                        files.push(result.data[i])
						console.log(result.data[i]);

                    }

                } else {
                    console.log(result)

                }
            })
            return files
        },
			//查看当前用户活动
			mygetActivityList() {
			listCurrentActivity(this.queryInfo).then(result => {
				if (result.code === '0000') {
					var tempArray = result.data[0];
					var j = 0;
					var z=0;
					var newWxdArray = [];
					var newQnxxArray=[];
					//查找符合条件值并存入新数组
					for (let i in tempArray) {
						if (tempArray[i].type == '微心愿_思想汇报') {
							newWxdArray[j++] = tempArray[i]
						} else if (tempArray[i].type == '微心愿_帮扶计划') {
							newWxdArray[j++] = tempArray[i]
						}else if(tempArray[i].type == '微心愿_青年大学习') {
							newQnxxArray[z++] = tempArray[i]
						}
						if (tempArray[i].approve == 0) {
							tempArray[i].approve = '未审核';
						} else if (tempArray[i].approve == 1) {
							tempArray[i].approve = '已通过';
						} else if (tempArray[i].approve == 2) {
							tempArray[i].approve = '未通过';
						}
					}
					this.wxyList = newWxdArray;
					this.qnxxList=newQnxxArray;
					this.count = result.data[1][0];
				} else {
					console.log(result)
				}
			})
		},	mydeleteActivity(id) {
			const parma = { 'id': id };
			deleteActivity(parma).then(result => {
				if (result.code === '0000') {
					this.$message.success('删除成功');
					this.mygetActivityList();
				} else {
					console.log(result)
				}
			})
		},



	}


}
</script>

<style>
.title {
	font-size: 20px;
}

.basicInfo {
	height: 300px;
	width: 500px;
	background-color: bisque;
}

.el-button--primary {
	background-color: darkred;
	color: #fff;
	border-color: darkred;
	width: 130px;
	font-size: 18px;
}

.table .el-button--primary:focus,
.table .el-button--primary:hover {
	background: #b22822;
	border-color: #b22822;
}

.myRow {
	margin-top: 100px;
	margin-bottom: 20px;

}
</style>
